import React, { useEffect, useState } from "react"
import { graphql } from "gatsby";
import { useTheme } from '~/contexts/ThemeContext'
import { Seo } from '~/components/shared/seo'
import useCareersHook from '~/utils/careers'
import { notBlank, imgSize } from '~/utils/helpers'

import { aria_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/pages/careers.module.scss"
import * as swtch from "~/styles/shared/undrtoggle.module.scss"


const Careers = ({ data: { json } }) => {
  const { isMobile } = useTheme()
  const page = json.data
  const { getData } = useCareersHook()

  const [corp, setCorp] = useState([])
  const [retail, setRetail] = useState([])

  const [currJobs, setCurrJobs] = useState(false)
  const [currMenu, setCurrMenu] = useState(false)
  const [open, setOpen] = useState('menu')

  const get_data = async () => {
    const json = await getData()
    setCorp(json.corp)
    setRetail(json.retail)
  }

  const handleCorp = (title) => {
    const item = corp.find(x => x.title === title)
    setCurrJobs(item)
    setCurrMenu('corp')

    if (!isMobile) return
    setOpen('jobs')
  }

  const handleRetail = (title) => {
    const item = retail.flat().find(x => x.title === title)
    setCurrJobs(item)
    setCurrMenu('retail')

    if (!isMobile) return
    setOpen('jobs')
  }

  useEffect(() => {
    get_data()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])


  return (
    <>
      <h1 style={{display: 'none'}}>Careers</h1>

      <div className={styles.careers_hero}>
        {(isMobile && notBlank(page.hero_mobile_image)) ? (
          <img src={imgSize(page.hero_mobile_image,900)} className={styles.img} alt='Interior of a Buck Mason store' />
        ) : (
          <img src={imgSize(page.hero_image,1400)} className={styles.img} alt='Interior of a Buck Mason store' />
        )}
      </div>

      <section className={styles.careers_message}>
        <div className={styles.careers_cont}>
          {notBlank(page.message_title) && (<div dangerouslySetInnerHTML={{ __html: page.message_title }} />)}
        </div>
      </section>

      {(corp?.length < 1 && retail?.length < 1) && (
        <div className={styles.loading}>
          <div className={styles.type_title}>
            Loading
          </div>
        </div>
      )}

      {(corp?.length > 0 && retail?.length > 0) && (
        <section 
          className={[styles.sec].join(' ')}
        >
          <div 
            className={[styles.cats, styles.menu, !currMenu ? styles.mob : ''].join(' ')}
          >
            <div 
              className={[styles.cat, styles.corp, open === 'menu' ? styles.open : ''].join(' ')} 
            >
              {(!currJobs && !currMenu) ? (
                <div className={[styles.type_title, styles.nobtn].join(' ')}>
                  Corporate
                </div>
              ) : (
                <div className={[styles.type_title, swtch.swtch_btns].join(' ')}>
                  <button 
                    type="button"
                    className={[aria_btn, swtch.swtch_btn].join(' ')}
                    onClick={(e)=> setCurrMenu('corp')}
                    aria-current={currMenu === 'corp' ? 'true' : 'false'}
                  >
                    Corporate
                  </button>
                  <button 
                    type="button"
                    className={[aria_btn, swtch.swtch_btn].join(' ')}
                    onClick={(e)=> setCurrMenu('retail')}
                    aria-current={currMenu === 'retail' ? 'true' : 'false'}
                  >
                    Retail
                  </button>
                </div>
              )}
              {(!currMenu || currMenu === 'corp') ? (
                <>
                  {corp.map(item => 
                    <div key={item.title} className={[styles.sub, !currMenu || (currJobs && item.title === currJobs.title) ? styles.on : ''].join(' ')}>
                      <div className={styles.subtitle}>
                        <button
                          type="button"
                          className={styles.title_btn}
                          onClick={(e) => handleCorp(item.title)}
                          aria-current={!currJobs ? undefined : item.title === currJobs.title ? 'true' : 'false'}
                        >
                          {item.title}
                        </button>
                      </div>
                      {item.regions.map(region => 
                        <p key={`${item.title}-${region}`}>{region}</p>
                      )}
                      <p>{item.postings.length} Opening{item.postings.length > 1 ? 's' : ''}</p>
                    </div>
                  )}
                </>
              ) : (
                <div className={styles.mcols}>
                  {retail.map((group,index) => 
                    <div className={styles.col} key={`retail${index}`}>
                      {group.map(item => 
                        <div key={item.title} className={[styles.sub, item.title === currJobs.title ? styles.on : ''].join(' ')}>
                          <div className={styles.subtitle}>
                            <button
                              type="button"
                              className={styles.title_btn}
                              onClick={(e) => handleRetail(item.title)}
                              aria-current={item.title === currJobs.title ? 'true' : 'false'}
                            >
                              {item.title}
                            </button>
                          </div>
                          <p>{item.postings.length} Opening{item.postings.length > 1 ? 's' : ''}</p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
            {!currJobs && (
              <div 
                className={[styles.cat, styles.open].join(' ')}
              >
                <h2 className={styles.type_title}>
                  Retail
                </h2>
                <div className={styles.cols} style={{marginTop: '2.5em'}}>
                  {retail.map((group,index) => 
                    <div key={`retail${index}`} className={styles.col}>
                      {group.map(item => 
                        <div key={item.title} className={[styles.sub, styles.on].join(' ')}>
                          <div className={styles.subtitle}>
                            <button
                              type="button"
                              className={styles.title_btn}
                              onClick={(e) => {setCurrMenu('retail'); handleRetail(item.title)}}
                            >
                              {item.title}
                            </button>
                          </div>
                          <p>{item.postings.length} Opening{item.postings.length > 1 ? 's' : ''}</p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
            {currJobs && (
              <div 
                className={[styles.cat, open === 'jobs' ? styles.open : ''].join(' ')}
              >
                <div className={styles.mob_menu}>
                  <button 
                    type="button"
                    className={[aria_btn,styles.apply_btn].join(' ')}
                    onClick={(e)=>setOpen('menu')}
                  >
                    Careers Menu
                  </button>
                </div>

                <h2 className={styles.jobs_title}>
                  {currJobs.title}
                </h2>

                {currJobs.postings.map(item => 
                  <div key={item.id} className={styles.job}>
                    <a 
                      className={styles.job_link} 
                      href={item.hostedUrl} 
                      target={'_blank'} 
                      rel={'noreferrer'} 
                      aria-label={`${item.text} position details`}
                    >
                      <div className={styles.cont}>
                        <div className={styles.subtitle}>
                          {item.text}
                        </div>
                        <p>
                          {item.categories.commitment} - {item.categories.location}
                        </p>
                      </div>
                      <div className={styles.apply}>
                        <div className={styles.apply_btn}>Details</div>
                      </div>
                    </a>
                  </div>
                )}
              </div>
            )}
          </div>
        </section>
      )}
        
      {(!currJobs && !currMenu) && (
        <div className={styles.blind}>
          {corp?.length > 0 && corp.map(team => 
            <div key={`blindteam${team.title}`}>
              <strong>Corporate: {team.title}</strong>
              {team.postings.map(item => 
                <p key={`blindcorp${item.id}`}>
                  {item.text}&nbsp;-&nbsp;{item.descriptionBodyPlain}
                  <br/>
                  {item.categories.commitment} - {item.categories.location}
                  <br/>
                  <a href={item.hostedUrl}>Corporate: {team.title} {item.text}</a>
                </p>
              )}
            </div>
          )}
          {retail?.length > 0 && retail.flat().map(region => 
            <div key={`blindreg${region.title}`}>
              <strong>Retail: {region.title}</strong>
              {region.postings.map(item => 
                <p key={`blindretail${item.id}`}>
                  {item.text}&nbsp;-&nbsp;{item.descriptionBodyPlain}
                  <br/>
                  {item.categories.commitment} - {item.categories.location}
                  <br/>
                  <a href={item.hostedUrl}>Retail: {region.title} {item.text}</a>
                </p>
              )}
            </div>
          )}
        </div>
      )}
    </>
  )
}
export default Careers

export const Head = ({ data: { json } }) => (
  <Seo 
    title={'Careers'}
    description={json.data.message_title}
    image={json.data.metaimg}
    url={`/pages/careers/`}
  />
)


export const pageQuery = graphql`
  {
    json: contentPage(type: {eq: "Careers"}) {
      data
    }
  }
`;



